<template>
  <div class="bienvenida-page">
    <p class="versiculo-referencia-fija" ref="versiculoRef"> </p>

    <!-- Contenedor fecha -->
    <div class="fecha-evento" ref="fechaRef">
      <p class="fecha-gran-dia" ref="granDiaRef">Save the Date</p>
      <p class="fecha-dia-semana" ref="diaSemanaRef">Sábado</p>
      <p class="fecha-dia-numero" ref="numeroRef">07</p>
      <p class="fecha-mes" ref="mesRef">NOVIEMBRE</p>
      <p class="fecha-anio" ref="anioRef">2026</p>
    </div>

    <!-- Contenido principal -->
    <div class="bienvenida-container">
      <div class="contenido-bienvenida">
        <div class="mensaje-bienvenida" ref="mensajeRef">
          {{ mensaje }}
        </div>
        <div class="versiculo-container" ref="versiculoTextRef">
          <p class="versiculo-texto">
            Había una vez una princesa llamada <br><span class="letra-quince"> Kenia</span>
            <br>que desde pequeña guardo un sueño en sú corazón…  soñaba con verse vestida como una princesa, como en un cuento de hadas. <br><br>
        
Será un privilegio compartir contigo este momento tan especial, donde cada sonrisa, abrazo y oración serán parte de un recuerdo inolvidable.

Tu presencia será una bendición en esta celebración tan significativa para mi vida y mi familia.            <br><br>
          </p>
  </div>
        <div class="versiculo-final" ref="versiculoFinalRef">
  <p class="texto-versiculo">
  </p>

  <p class="referencia-versiculo">
  </p>
</div>

      
      </div>
    </div>

    <!-- Grupo decorativo 1 (Con Rama Larga) -->
    <div class="disco-group disco1-group">
      <img src="@/assets/rama.png" alt="rama" class="rama-decorativa" ref="rama1Ref" />
      <img src="@/assets/fl.png" alt="disco" class="disco" ref="disco1Ref" />
    </div>

    <!-- Grupo decorativo 2 (Con Rama Larga) -->
    <div class="disco-group disco2-group">
      <img src="@/assets/rama.png" alt="rama" class="rama-decorativa" ref="rama2Ref" />
      <img src="@/assets/fl.png" alt="disco" class="disco" ref="disco2Ref" />
    </div>

    <!-- Grupo decorativo 3 -->
    <div class="disco-group disco3-group">
      <img src="@/assets/fl.png" alt="disco" class="disco" ref="disco3Ref" />
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'BienvenidaPage',

  setup() {

    const mensaje = ref('');

    const granDiaRef = ref(null);
    const diaSemanaRef = ref(null);
    const numeroRef = ref(null);
    const mesRef = ref(null);
    const anioRef = ref(null);

    const mensajeRef = ref(null);
    const versiculoTextRef = ref(null);
    const versiculoRef = ref(null);

    const disco1Ref = ref(null);
    const disco2Ref = ref(null);
    const disco3Ref = ref(null);

    const rama1Ref = ref(null);
    const rama2Ref = ref(null);

    const animateOnScroll = (el, animationFn) => {

      if (!el) return;

      const observer = new IntersectionObserver(

        ([entry]) => {

          if (entry.isIntersecting) {

            animationFn();

            observer.unobserve(el);

          }

        },

        {
          threshold: 0.3
        }

      );

      observer.observe(el);

    };

    onMounted(() => {

      // ✨ TIMELINE CONSECUTIVO
      const iniciarAnimacion = () => {

        const tl = gsap.timeline({
          defaults: {
            ease: 'power2.out'
          }
        });

        // SAVE THE DATE
        tl.fromTo(
          granDiaRef.value,
          {
            opacity: 0,
            y: 40
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.8
          }
        )

        // DOMINGO
        .fromTo(
          diaSemanaRef.value,
          {
            opacity: 0,
            y: 25
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.6
          },
          '-=0.4'
        )

        // 21
        .fromTo(
          numeroRef.value,
          {
            opacity: 0,
            scale: 0.5,
            y: -80,
            rotate: -8
          },
          {
            opacity: 1,
            scale: 1,
            y: 0,
            rotate: 0,
            duration: 1,
            ease: 'back.out(1.7)'
          },
          '-=0.2'
        )

        // MES
        .fromTo(
          mesRef.value,
          {
            opacity: 0,
            y: 20
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.6
          },
          '-=0.5'
        )

        // AÑO
        .fromTo(
          anioRef.value,
          {
            opacity: 0,
            y: 20
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.6
          },
          '-=0.45'
        )

        // MENSAJE
        .fromTo(
          mensajeRef.value,
          {
            opacity: 0,
            y: 50
          },
          {
            opacity: 1,
            y: 0,
            duration: 1
          },
          '-=0.2'
        )

        // TEXTO PRINCIPAL
        .fromTo(
          versiculoTextRef.value,
          {
            opacity: 0,
            y: 40,
            filter: 'blur(10px)'
          },
          {
            opacity: 1,
            y: 0,
            filter: 'blur(0px)',
            duration: 1.2
          },
          '-=0.5'
        );

        // ✨ FLOR + RAMA 1
        tl.fromTo(
          disco1Ref.value,
          {
            opacity: 0,
            rotate: -20,
            scale: 0.4
          },
          {
            opacity: 1,
            rotate: 0,
            scale: 1,
            duration: 1,
            ease: "back.out(1.7)"
          },
          '-=1'
        );

        tl.fromTo(
          rama1Ref.value,
          {
            opacity: 0,
            scale: 0,
            transformOrigin: "center center"
          },
          {
            opacity: 1,
            scale: 1,
            duration: 1.2,
            ease: "elastic.out(1, 0.5)"
          },
          '-=0.8'
        );

        // ✨ FLOR + RAMA 2
        tl.fromTo(
          disco2Ref.value,
          {
            opacity: 0,
            rotate: 20,
            scale: 0.4
          },
          {
            opacity: 1,
            rotate: 0,
            scale: 1,
            duration: 1,
            ease: "back.out(1.7)"
          },
          '-=1'
        );

        tl.fromTo(
          rama2Ref.value,
          {
            opacity: 0,
            scale: 0,
            transformOrigin: "center center"
          },
          {
            opacity: 1,
            scale: 1,
            duration: 1.2,
            ease: "elastic.out(1, 0.5)"
          },
          '-=0.8'
        );

        // ✨ FLOR 3
        tl.fromTo(
          disco3Ref.value,
          {
            opacity: 0,
            scale: 0.4,
            rotate: -10
          },
          {
            opacity: 1,
            scale: 1,
            rotate: 0,
            duration: 1,
            ease: "back.out(1.7)"
          },
          '-=1'
        );

      };

      animateOnScroll(
        granDiaRef.value,
        iniciarAnimacion
      );

    });

    return {

      mensaje,

      granDiaRef,
      diaSemanaRef,
      numeroRef,
      mesRef,
      anioRef,

      mensajeRef,
      versiculoTextRef,
      versiculoRef,

      disco1Ref,
      disco2Ref,
      disco3Ref,

      rama1Ref,
      rama2Ref

    };
  }
};
</script>

<style scoped>
.bienvenida-page {
  background: transparent;
  color: black;
  min-height: 100vh;
  padding: 0px 20px;
  margin-bottom: 5px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden; /* Para que las ramas largas no den problemas */
}

/* Fecha Estilo Dorado */
.fecha-evento {
  text-align: center;
  margin: 60px 0 40px;
  position: relative;
  z-index: 5;
}

.fecha-gran-dia, .fecha-dia-semana, .fecha-dia-numero, .fecha-mes, .fecha-anio {
 background: linear-gradient(
    110deg,
    #375557 30%,
    #3f88bf 45%,
    #8fa8bc 50%,
    #a9b4da 55%,
    #7fafe0 70%
  );
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;

  filter: drop-shadow(0px 2px 3px rgba(0,0,0,0.5));  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  filter: drop-shadow(0px 1px 1px rgba(0,0,0,0.3));
  display: block;
  margin: 0 auto;
}

.fecha-gran-dia { font-family: 'CynthiaJuneJF', cursive; font-size: 62px; }
.fecha-dia-semana { font-family: 'fecha', serif; font-size: 29px; margin: 10px 0; }
.fecha-dia-numero { font-family: 'fecha', serif; font-size: 72px !important; font-weight: bold; }
.fecha-mes { font-family: 'Playfair Display', serif; font-size: 26px; font-weight: 600; letter-spacing: 2px; }
.fecha-anio { font-family: 'Poppins', sans-serif; font-size: 16px; font-style: italic; }

/* Contenido */
.bienvenida-container { display: flex; flex-direction: column; align-items: center; }
.mensaje-bienvenida { font: 300 19px 'Josefin Sans', sans-serif; color: #000; text-align: center; line-height: 2; }
.versiculo-container { margin: -20px 20px 0; text-align: center; }
.versiculo-texto { font: 18px 'quote', sans-serif; line-height: 1.8; color: #333; }
.letra-quince {
  font-family: 'CynthiaJuneJF', cursive; font-size: 64px;
 background: linear-gradient(
    110deg,
    #375557 30%,
    #3f88bf 45%,
    #8fa8bc 50%,
    #8890ad 55%,
    #7fafe0 70%
  );
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;

  filter: drop-shadow(0px 2px 3px rgba(0,0,0,0.5));  -webkit-background-clip: text; background-clip: text; color: transparent;
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.3));
}

/* Decoraciones */
.disco-group {
  position: absolute;
  pointer-events: none;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.disco {
  width: 140px;
  height: auto;
  position: relative;
  z-index: 2; /* Flor al frente */
}

.rama-decorativa {
  position: absolute;
  width: 270px; /* Rama más larga que la flor */
  height: auto;
  margin-top:60px;
  z-index: 1; /* Rama atrás */
  opacity: 0;
  filter: brightness(1.1); /* Toque de luz */
}
.versiculo-final{
  margin-top: 30px;
  width: 100%;
  position: relative;
}

.texto-versiculo{
  font-family: "Playfair Display", serif;
  font-size: 1.15rem;
  line-height: 1.8;
  color: #3d3c3c;
  text-align: center;
  font-style: italic;
  margin-bottom: 10px;
}

.referencia-versiculo{
  font-family: "Playfair Display", serif;
  font-size: 1rem;
  color: #9d7b52;
  text-align: right;
  padding-right: 15px;
  letter-spacing: 1px;
}
/* Posiciones */
.disco1-group { top: -2%; right: -15%; width: 150px !important;  }
.disco2-group { top: 20%; left: -12%; width: 120px; }
.disco3-group { bottom: -10%; left: -10%; z-index:10; }
</style>